import React from 'react';
import { WebsiteLayout } from '../../components/WebsiteLayout';
import type { Site } from '../../schemas/validation';
import { PreviewIndicator } from './PreviewIndicator';

interface PageNotFoundProps {
  isMimicking: boolean;
  website: Site;
  navigation: Array<{ title: string; slug: string; orderPosition: number }>;
  theme: any;
  siteId: string | undefined;
  currentSlug: string;
  onNavigateHome: () => void;
}

export const PageNotFound: React.FC<PageNotFoundProps> = ({
  isMimicking,
  website,
  navigation,
  theme,
  siteId,
  currentSlug,
  onNavigateHome,
}) => (
  <div className={`min-h-screen ${isMimicking ? 'mt-[52px]' : ''}`}>
    <PreviewIndicator />

    <WebsiteLayout
      website={website}
      navigation={navigation}
      theme={theme}
      isPreviewMode={true}
      previewSiteId={siteId}
    >
      <div className="min-h-96 flex items-center justify-center">
        <div className="text-center max-w-md mx-auto px-4">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Page Not Found</h1>
          <p className="text-gray-600 mb-6">
            The page "{currentSlug}" could not be found on this website.
          </p>
          <button
            onClick={onNavigateHome}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 transition-colors"
          >
            Go to Homepage
          </button>
        </div>
      </div>
    </WebsiteLayout>
  </div>
);
